const CryptoJS = require("crypto-js");
const secret_key = process.env.REACT_APP_MY_SECRET_KEY;


class Utility {

    constructor() {}

    encryptData(value){
        return CryptoJS.AES.encrypt(value, secret_key).toString();
    }

    decryptData(value){
        return CryptoJS.AES.decrypt(value, secret_key).toString(CryptoJS.enc.Utf8);
    }
}

module.exports = Utility;